import React, { useState, useMemo, useEffect, useRef } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";

//   import proimage from '../assets/images/proimage.svg';
//   import proimage1 from '../assets/images/proimage1.svg';

import proimage from "../../assets/images/proimage.svg";
import proimage1 from "../../assets/images/proimage1.svg";

import { faPlus, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import {
  faSquarePlus,
  faSquareMinus,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../../config/Config";
import Select from "react-select";
import Editor from "../common/Editor";
import Spinner from "react-activity/dist/Spinner";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const AddNewProduct = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [showloding, setshowloding] = useState(false);
  const [editorLoaded, setEditorLoaded] = useState(true);
  const [forceupdate, setforceupdate] = useState(false);

  const [categorydata, setcategorydata] = useState([]);
  const [subcategorydata, setsubcategorydata] = useState([]);
  const [labelsdata, setlabelsdata] = useState([]);
  const [tagsdata, settagsdata] = useState([]);

  const [selectedtag, setselectedtag] = useState("");
  const [selectedlabel, setselectedlabel] = useState("");
  const [description, setdescription] = useState("");

  const [productname, setproductname] = useState("");
  const [mrpprice, setmrpprice] = useState("");
  const [sellingprice, setsellingprice] = useState("");
  const [stock, setstock] = useState("");
  const [rating, setrating] = useState("");
  const [ratingcount, setratingcount] = useState("");

  const [selectedcategory, setselectedcategory] = useState("");
  const [selectedsubcategory, setselectedsubcategory] = useState("");

  const fileInputRefs = useRef([]);

  const [infosectionarr, setinfosectionarr] = useState([
    { title: "", description: "" },
  ]);

  const infosectionarrRef = useRef([]);
  infosectionarrRef.current = infosectionarr;

  const [colorsarr, setcolorsarr] = useState([{ name: "", hexcode: "", qty: 0 }]);

  const colorsarrRef = useRef([]);
  colorsarrRef.current = colorsarr;

  const [sizearr, setsizearr] = useState([{ name: "", shortcode: "", qty: 0 }]);

  const sizearrRef = useRef([]);
  sizearrRef.current = sizearr;

  const [imagesarr, setimagesarr] = useState([{ name: "", image: "" }]);

  const imagesarrRef = useRef([]);
  imagesarrRef.current = imagesarr;

  const handleplussizesection = () => {
    var prevdata = sizearrRef.current;
    var obj = { name: "", shortcode: "", qty: 0 };
    prevdata.push(obj);
    setsizearr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handleminussizesection = () => {
    if (sizearrRef.current?.length > 1) {
      var prevdata = sizearrRef.current;
      prevdata.pop();
      setsizearr(prevdata);
      setforceupdate(!forceupdate);
    }
  };

  const handlechangesizeinput = (index, key, value) => {
    var prevdata = sizearrRef.current;
    prevdata[index][key] = value;
    setsizearr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handlepluscoloursection = () => {
    var prevdata = colorsarrRef.current;
    var obj = { name: "", hexcode: "", qty: 0 };
    prevdata.push(obj);
    setcolorsarr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handleminuscoloursection = () => {
    if (colorsarrRef.current?.length > 1) {
      var prevdata = colorsarrRef.current;
      prevdata.pop();
      setcolorsarr(prevdata);
      setforceupdate(!forceupdate);
    }
  };

  const handlechangecolourinput = (index, key, value) => {
    var prevdata = colorsarrRef.current;
    prevdata[index][key] = value;
    setcolorsarr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handleplusinfosection = () => {
    var prevdata = infosectionarrRef.current;
    var obj = { title: "", description: "" };
    prevdata.push(obj);
    setinfosectionarr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handleminusinfosection = () => {
    if (infosectionarrRef.current?.length > 1) {
      var prevdata = infosectionarrRef.current;
      prevdata.pop();
      setinfosectionarr(prevdata);
      setforceupdate(!forceupdate);
    }
  };

  const handlechangeinfoinput = (index, key, value) => {
    var prevdata = infosectionarrRef.current;
    prevdata[index][key] = value;
    setinfosectionarr(prevdata);
    setforceupdate(!forceupdate);
  };

  // console.log('infosectionarrRef.current >>', infosectionarrRef.current);

  const handleplusimg = () => {
    var obj = { name: "", image: "" };
    var prevdata = imagesarrRef.current;
    prevdata.push(obj);
    setimagesarr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handlesubmitproduct = async(status) => {
    // navigate('/coupons')
    setshowloding(true);
    if(productname && selectedcategory && mrpprice && sellingprice && stock) {

      var prevtags = selectedtag;
      var newtagsdata = [];
      for(var i = 0; i < prevtags?.length; i++) {
        newtagsdata.push(prevtags[i]?.value);
      }

      var prevtags = selectedlabel;
      var newlabelsdata = [];
      for(var i = 0; i < prevtags?.length; i++) {
        newlabelsdata.push(prevtags[i]?.value);
      }

      var prevsinfosectionsarr = infosectionarrRef?.current;
      var newsectionarrdata = [];
      for(var i = 0; i < prevsinfosectionsarr?.length; i++) {
        if(prevsinfosectionsarr[i]?.title && prevsinfosectionsarr[i]?.description) {
          newsectionarrdata.push(prevsinfosectionsarr[i]);
        }
      }

      var prevcolourarr = colorsarrRef?.current;
      var newcoloursdata = [];
      for(var i = 0; i < prevcolourarr?.length; i++) {
        if(prevcolourarr[i]?.name && prevcolourarr[i]?.hexcode) {
          newcoloursdata.push(prevcolourarr[i]);
        }
      }

      var prevsizearr = sizearrRef?.current;
      var newsizesdata = [];
      for(var i = 0; i < prevsizearr?.length; i++) {
        if(prevsizearr[i]?.name && prevsizearr[i]?.shortcode) {
          newsizesdata.push(prevsizearr[i]);
        }
      }

      var data = {
        name: productname,
        category: selectedcategory,
        subcategory: selectedsubcategory,
        mrpprice: mrpprice,
        sellingprice: sellingprice,
        stock: stock,
        tagsarr: newtagsdata?.length > 0 ? newtagsdata : null,
        labelsarr: newlabelsdata?.length > 0 ? newlabelsdata : null,
        description: description,
        infosectionarr: newsectionarrdata?.length > 0 ? newsectionarrdata : null,
        colorsarr: newcoloursdata?.length > 0 ? newcoloursdata : null,
        sizearr: newsizesdata?.length > 0 ? newsizesdata : null,
        imagesarr: imagesarrRef?.current,
        rating: rating,
        rating_count: ratingcount,
        status: status == 1 ? "true" : "false"
      }
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "createproduct",data, headers)
        .then((res) => {
          // console.log('res >>', res.data)
          // category data
          if (res?.data?.status == "success") {
           navigate('/admin/products');
          } else {
            if (res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} });
              navigate("/admin/login");
            } else {
              alert(res.data.message);
            }
          }
        })
        .catch((err) => {
          console.log("err >>", err);
        });

      console.log("data >>", data);
    } else {
      alert("Fill all required details")
    }
    
    setshowloding(false);
    
  };

  const fetchdata = async () => {
    // setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
      .get(apiUrl + "getaddproductsdropdown", headers)
      .then((res) => {
        // console.log('res >>', res.data)
        // category data
        if (res?.data?.status == "success") {
          //category data
          if (res?.data?.categorydata?.length > 0) {
            setcategorydata(res?.data?.categorydata);
          } else {
            setcategorydata([]);
          }

           // Subcategories data
           if (res?.data?.subcategories?.length > 0) {
            setsubcategorydata(res?.data?.subcategories);
          } else {
            setsubcategorydata([]);
          }

          // labels data
          if (res?.data?.labelsdata?.length > 0) {
            setlabelsdata(res?.data?.labelsdata);
          } else {
            setlabelsdata([]);
          }
          //tags data
          if (res?.data?.tagsdata?.length > 0) {
            settagsdata(res?.data?.tagsdata);
          } else {
            settagsdata([]);
          }
        } else {
          if (res.data.message == "invalid user") {
            dispatch({ type: "userdata", payload: {} });
            navigate("/admin/login");
          } else {
            alert(res.data.message);
          }
        }
      })
      .catch((err) => {
        console.log("err >>", err);
      });
    // setshowloding(false);
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleImageClick = (index) => {
    // Trigger the specific file input for the clicked image
    fileInputRefs.current[index].click();
  };

  const handleFileChange = async (event, index) => {
    var prevdata = imagesarrRef.current;
    const file = event.target.files[0];
    var obj = {};
    await getBase64(file).then((result) => {
      prevdata[index]["name"] = file.name;
      prevdata[index]["image"] = result;
    });
    console.log("prevdata[index] >>", prevdata[index]);
    setimagesarr(prevdata);
    setforceupdate(!forceupdate);
  };

  const handleremoveimage = async (index) => {
    var prevdata = imagesarrRef.current;
    if (index == 0) {
      prevdata[index]["name"] = "";
      prevdata[index]["image"] = "";
    } else {
      prevdata.splice(index, 1);
    }

    setimagesarr(prevdata);
    setforceupdate(!forceupdate);
  };
  // console.log('imagesarr >>', imagesarrRef.current)

  useEffect(() => {
    if (userdata && Object.keys(userdata).length > 0) {
      fetchdata();
    } else {
      navigate("/admin/login");
    }
  }, []);

  return (
    <div className="">
      <div className="dashboardbox" style={{ width: "100%" }}>
        <div className="inventorysave-row addproduct-save-row">
          <p className="inventorysummary-text addproduct-text">
            Add New Product
          </p>
          <div className="inventory-save-btn add-product-btn add-product-btn1"
          onClick={() => {if(!showloding) { handlesubmitproduct(0) } else {}}}
          >
            {showloding ?
                <Spinner color='#2e2382' size={15} className='spinnerCenter' /> : <p>Save as draft</p>
            }
            
          </div>
          <div
            className="inventory-save-btn add-product-btn"
            onClick={() => {if(!showloding) { handlesubmitproduct(1) } else {}}}
          >
            {showloding ?
                <Spinner color='#fff' size={15} className='spinnerCenter' /> : <p>Save & Publish</p>
            }
            
          </div>
        </div>
        <div className="inventorysummaryrow row mt-3">
          <div className="col-md-4 addproduct_reduce_width">
            <div className="">
              <label className="addproduct-label">Product Name *</label>
              <input
                className="form-control addproductinput"
                placeholder="Name"
                value={productname}
                onChange={(t) => {setproductname(t.target.value)}}
              />
            </div>
            <div className="mt-3">
              <label className="addproduct-label">Product category *</label>
              <select className="form-control addproductinput" value={selectedcategory} onChange={(t) => {setselectedcategory(t.target.value)}}>
                <option value={""} selected disabled>
                  Select Category
                </option>
                {categorydata?.map((item, index) => {
                  return (
                    <option key={index} value={item?.categoryid}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="mt-3">
              <label className="addproduct-label">Product Subcategory *</label>
              <select className="form-control addproductinput" value={selectedsubcategory} onChange={(t) => {setselectedsubcategory(t.target.value)}}>
                <option value={""} selected disabled>
                  Select Sub Category
                </option>
                {subcategorydata?.map((item, index) => {
                  // console.log('selectedcategory item >>', selectedcategory);
                  // console.log('subcategorydata item >>', item);
                  if(item?.categoryid == selectedcategory) {
                    return (
                      <option key={index} value={item?.id}>
                        {item?.title}
                      </option>
                    );
                  }
                })}
              </select>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <label className="addproduct-label">MRP Price *</label>
                <input
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter Amount"
                  value={mrpprice}
                onChange={(t) => {setmrpprice(t.target.value)}}
                />
              </div>
              <div className="col-md-6">
                <label className="addproduct-label">Selling Price *</label>
                <input
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter Amount"
                  value={sellingprice}
                onChange={(t) => {setsellingprice(t.target.value)}}
                />
              </div>
            </div>
            <div className="mt-3">
              <label className="addproduct-label">Quantity in Stock *</label>
              <input
                type="number"
                className="form-control addproductinput"
                placeholder="Enter Quantity"
                value={stock}
                onChange={(t) => {setstock(t.target.value)}}
              />
            </div>
            <div className="mt-3">
              <label className="addproduct-label">Tags</label>
              <Select
                isMulti
                closeMenuOnSelect={false}
                value={selectedtag}
                onChange={setselectedtag}
                options={tagsdata}
                className="offerselectdropdown"
              />
            </div>
            <div className="mt-3">
              <label className="addproduct-label">Labels</label>
              <Select
                isMulti
                closeMenuOnSelect={false}
                value={selectedlabel}
                onChange={setselectedlabel}
                options={labelsdata}
                className="offerselectdropdown"
              />
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <label className="addproduct-label">Rating *</label>
                <input
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter Rating"
                  value={rating}
                  onChange={(t) => {setrating(t.target.value)}}
                />
              </div>
              <div className="col-md-6">
                <label className="addproduct-label">Rating Count *</label>
                <input
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter Count"
                  value={ratingcount}
                  onChange={(t) => {setratingcount(t.target.value)}}
                />
              </div>
            </div>
            {/* <div className="mt-3">
                <label className="addproduct-label">Order Type</label>
                <select className="form-control addproductinput">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
              </div>
              <div className="mt-3">
                <div className="addproduct-discountrow">
                  <p className="addproduct-discounttext">Discount</p>
                  <p
                    className="addproduct-discounttext"
                    style={{
                      fontSize: 13,
                      marginLeft: "auto",
                      marginRight: 10,
                    }}
                  >
                    Add Discount
                  </p>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </div>
                <div className="addproduct-discountrow mt-3">
                  <p className="addproduct-discounttext">Expiry Date</p>
                  <p
                    className="addproduct-discounttext"
                    style={{
                      fontSize: 13,
                      marginLeft: "auto",
                      marginRight: 10,
                    }}
                  >
                    Add Expiry Date
                  </p>
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </div>
              </div> */}
          </div>
          <div className="col-md-4 addproduct_reduce_width">
            <div className="">
              <label className="addproduct-label">Product Details</label>
              <div className="descriptionckeditor" style={{ marginTop: 7 }}>
                <Editor
                  name="name"
                  value={description}
                  onChange={(data) => {
                    setdescription(data);
                  }}
                  editorLoaded={editorLoaded}
                  className="addproductinput"
                />
              </div>
            </div>
            <div className="mt-3" style={{ marginTop: 30 }}>
              <div  style={{display: 'flex', flexDirection: 'row'}}>
                <label className="addproduct-label" style={{ marginTop: 5 }}>
                  Info Section
                </label>
                <div
                  className=""
                  onClick={() => {
                    handleplusinfosection();
                  }}
                  style={{
                    marginLeft: "auto",
                    marginRight: 5,
                    cursor: "pointer",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSquarePlus}
                    className="addsectionicon"
                    style={{fontSize: 22}}
                  />
                </div>
                <div
                  className=""
                  onClick={() => {
                    handleminusinfosection();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={faSquareMinus}
                    className="addsectionicon"
                    style={{fontSize: 22}}
                  />
                </div>
              </div>
              {infosectionarr?.length > 0 ? (
                <div className="infosectionborder">
                  {infosectionarr?.map((item, index) => {
                    return (
                      <div className="infosectionsinglediv" key={index}>
                        <input
                          type="text"
                          value={item.title}
                          onChange={(t) => {
                            handlechangeinfoinput(
                              index,
                              "title",
                              t.target.value
                            );
                          }}
                          className="form-control addproductinput"
                          placeholder={`${index + 1}. Title`}
                        />
                        <div
                          className="infosectionckeditor"
                          style={{ marginTop: 7 }}
                        >
                          <Editor
                            name="name"
                            value={item.description}
                            onChange={(t) => {
                              handlechangeinfoinput(index, "description", t);
                            }}
                            editorLoaded={editorLoaded}
                            className="addproductinput"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-4 addproduct_reduce_width">
            <div className="row" style={{ marginTop: 0 }}>
              <div  style={{display: 'flex', flexDirection: 'row'}}>
                <label className="addproduct-label" style={{ marginTop: 0 }}>
                  Colour Variant
                </label>
                <div
                  className=""
                  onClick={() => {
                    handlepluscoloursection();
                  }}
                  style={{
                    marginLeft: "auto",
                    marginRight: 5,
                    cursor: "pointer",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSquarePlus}
                    className="addsectionicon"
                    style={{fontSize: 22}}
                  />
                </div>
                <div
                  className=""
                  onClick={() => {
                    handleminuscoloursection();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={faSquareMinus}
                    className="addsectionicon"
                    style={{fontSize: 22}}
                  />
                </div>
              </div>
              {colorsarrRef?.current?.length > 0 ? (
                <div className="infosectionborder">
                  {colorsarrRef?.current?.map((item, index) => {
                    return (
                      <div className="coloursarrsinglediv row" style={{justifyContent: 'space-between'}} key={index}>
                      <div  style={{ width: "42%", padding: 0 }}>
                        <input
                          type="text"
                          value={item.name}
                          onChange={(t) => {
                            handlechangecolourinput(
                              index,
                              "name",
                              t.target.value
                            );
                          }}
                          className="form-control addproductinput"
                          placeholder={`${index + 1}. Colour Name`}
                        />
                      </div>
                      <div  style={{ width: "29%", padding: 0 }}>
                        <input
                          type="text"
                          value={item.hexcode}
                          onChange={(t) => {
                            handlechangecolourinput(
                              index,
                              "hexcode",
                              t.target.value
                            );
                          }}
                          maxLength={6}
                          className="form-control addproductinput"
                          placeholder={`Hex (no #)`}
                        />
                      </div>
                      <div  style={{ width: "24%", padding: 0 }}>
                        <input
                          type="number"
                          value={item?.qty}
                          defaultValue={0}
                          onChange={(t) => {
                            handlechangecolourinput(
                              index,
                              "qty",
                              t.target.value
                            );
                          }}
                          className="form-control addproductinput"
                          placeholder={`Qty`}
                        />
                      </div>
                    </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
            <div className="mt-3" style={{ marginTop: 30 }}>
              <div className="flex" style={{display: 'flex', flexDirection: 'row'}}>
                <label className="addproduct-label" style={{ marginTop: 0 }}>
                  Size Variant
                </label>
                <div
                  className=""
                  onClick={() => {
                    handleplussizesection();
                  }}
                  style={{
                    marginLeft: "auto",
                    marginRight: 5,
                    cursor: "pointer",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSquarePlus}
                    className="addsectionicon"
                    style={{fontSize: 22}}
                  />
                </div>
                <div
                  className=""
                  onClick={() => {
                    handleminussizesection();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={faSquareMinus}
                    className="addsectionicon"
                    style={{fontSize: 22}}
                  />
                </div>
              </div>
              {sizearrRef?.current?.length > 0 ? (
                <div className="infosectionborder row">
                  {sizearrRef?.current?.map((item, index) => {
                    return (
                      <div className="coloursarrsinglediv row" style={{justifyContent: 'space-between'}} key={index}>
                        <div  style={{ width: "42%", padding: 0 }}>
                          <input
                            type="text"
                            value={item.name}
                            onChange={(t) => {
                              handlechangesizeinput(
                                index,
                                "name",
                                t.target.value
                              );
                            }}
                            className="form-control addproductinput"
                            placeholder={`${index + 1}. Variant Name`}
                          />
                        </div>
                        <div  style={{ width: "29%", padding: 0 }}>
                          <input
                            type="text"
                            value={item.shortcode}
                            onChange={(t) => {
                              handlechangesizeinput(
                                index,
                                "shortcode",
                                t.target.value
                              );
                            }}
                            className="form-control addproductinput"
                            placeholder={`Shortcode`}
                          />
                        </div>
                        <div  style={{ width: "24%", padding: 0 }}>
                        <input
                          type="number"
                          value={item?.qty}
                          defaultValue={0}
                          onChange={(t) => {
                            handlechangesizeinput(
                              index,
                              "qty",
                              t.target.value
                            );
                          }}
                          className="form-control addproductinput"
                          placeholder={`Qty`}
                        />
                      </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
            <div className="mt-3" style={{ marginTop: 30 }}>
              <label className="addproduct-label">Images</label>
              <div className="row imagesrow">
                {imagesarrRef.current?.length > 0
                  ? imagesarrRef.current?.map((item, index) => {
                      return (
                        <div className="col-md-4" key={index}>
                          {item?.image ? (
                            <div className="loadedbase64imagediv">
                              <img
                                src={item?.image}
                                className="loadedbase64image"
                              />
                              <FontAwesomeIcon
                                icon={faCircleXmark}
                                className="removeproducticon"
                                onClick={() => {
                                  handleremoveimage(index);
                                }}
                              />
                            </div>
                          ) : (
                            <div className="additional-img-bg">
                              <img
                                src={proimage}
                                className="addproductimage"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleImageClick(index);
                                }}
                              />
                              <div className="addproduct_upload_img_row d-flex">
                                <img
                                  src={proimage1}
                                  className="addproductimage1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleImageClick(index);
                                  }}
                                />
                                <p
                                  className="addproductimagetext"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    handleImageClick(index);
                                  }}
                                >
                                  Upload
                                </p>
                              </div>
                              {index == 0 ? null : (
                                <FontAwesomeIcon
                                  icon={faCircleXmark}
                                  className="removeproducticon"
                                  onClick={() => {
                                    handleremoveimage(index);
                                  }}
                                />
                              )}
                            </div>
                          )}

                          {/* Hidden file input for each image */}
                          <input
                            type="file"
                            style={{ display: "none" }}
                            accept="image/*"
                            ref={(el) => (fileInputRefs.current[index] = el)}
                            onChange={(e) => handleFileChange(e, index)}
                          />
                        </div>
                      );
                    })
                  : null}
                <div className="col-md-4">
                  <div
                    className="additional-img-bg additional-img-bg1"
                    onClick={() => {
                      handleplusimg();
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="addproducticon" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewProduct;
